const DEVURL = 'https://mimoville-server.onrender.com'
const FIELDS = { name: "", about: "", address: "", phone: "", price: "", photo: "", amenities: "", }

export { DEVURL, FIELDS }